import React from 'react'
import PropTypes from 'prop-types'


const RadioGroup = (props) => {
  const {label = ''} = props
  return (
    <div role='group' aria-label={label} {...props}>
      {props.children}
    </div>
  )
}

RadioGroup.propTypes = {
  label: PropTypes.string,
  children: PropTypes.array,
}

export default RadioGroup
